import { render, staticRenderFns } from "./ProjectTagForm.vue?vue&type=template&id=73a8737f&scoped=true&"
import script from "./ProjectTagForm.vue?vue&type=script&lang=js&"
export * from "./ProjectTagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a8737f",
  null
  
)

export default component.exports